// --- src/modules/procurement/PrintableShoppingList.tsx ---
// Print-only component for shopping list

import React from 'react';
import { SupplierMap } from '../../components/types';

export interface PrintableShoppingListProps {
  title?: string;
  items: Array<{
    ean: string;
    name: string;
    quantity: number;
  }>;
  supplierData: SupplierMap;
  selectedCount?: number;
}

export const PrintableShoppingList: React.FC<PrintableShoppingListProps> = ({
  title = 'Bevásárlólista',
  items,
  supplierData,
  selectedCount = 0,
}) => {
  const formatDate = () => new Date().toISOString().slice(0, 10);

  return (
    <div className="hidden print:block p-8 bg-white">
      <h1 className="text-3xl font-bold text-black mb-6">
        {title} - {formatDate()}
      </h1>
      {selectedCount > 0 && (
        <p className="text-sm text-gray-700 mb-4">Kijelölt tételek: {selectedCount} db</p>
      )}
      <table className="w-full border-collapse border border-gray-300 text-sm">
        <thead>
          <tr className="bg-gray-100">
            <th className="border border-gray-300 px-4 py-2 text-left font-bold text-black">
              Termék Neve
            </th>
            <th className="border border-gray-300 px-4 py-2 text-left font-bold text-black">
              Vonalkód
            </th>
            <th className="border border-gray-300 px-4 py-2 text-center font-bold text-black">
              Mennyiség
            </th>
            <th className="border border-gray-300 px-4 py-2 text-right font-bold text-black">
              Beszerzési Ár
            </th>
            <th className="border border-gray-300 px-4 py-2 text-right font-bold text-black">
              Eladási Ár
            </th>
          </tr>
        </thead>
        <tbody>
          {items.map((row) => {
            const suppItem = supplierData[row.ean];
            const netPrice = suppItem?.netPrice || 0;
            const sellingPrice = suppItem?.sellingPrice || 0;

            return (
              <tr key={row.ean} className="bg-white">
                <td className="border border-gray-300 px-4 py-2 text-black">{row.name}</td>
                <td className="border border-gray-300 px-4 py-2 text-black font-mono">{row.ean}</td>
                <td className="border border-gray-300 px-4 py-2 text-center text-black">
                  {row.quantity}
                </td>
                <td className="border border-gray-300 px-4 py-2 text-right text-black">
                  {netPrice.toLocaleString()} Ft
                </td>
                <td className="border border-gray-300 px-4 py-2 text-right text-black">
                  {sellingPrice.toLocaleString()} Ft
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
};
